// extracted by mini-css-extract-plugin
module.exports = {"container":"Pg-z","list":"Qg-z"};